
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqOIJ7VcoihhOiSOC79kGrDlRl_cW_450FkkD0rK4S0djQ8Meta } from "/codebuild/output/src1878434372/src/src/pages/faq.vue?macro=true";
import { default as menuOIk2iVH_45Y480zzxMYJtL7GCPBRtX7i9tKfgROut3F0cMeta } from "/codebuild/output/src1878434372/src/src/pages/menu.vue?macro=true";
import { default as indexGFOvnwIxLJHG_45HWHpdxVjJstf2DoVHo_459mm_4558a44MYMeta } from "/codebuild/output/src1878434372/src/src/pages/index.vue?macro=true";
import { default as contactemxTXu_45M9iLgW_45b9ma7MLvcgsLCPaHd5WBRsL_KCeQkMeta } from "/codebuild/output/src1878434372/src/src/pages/contact.vue?macro=true";
import { default as tutorialC4PWG_kQ1gaS71LrDho6uFOJHI7f_456gION8_52Vpd8QMeta } from "/codebuild/output/src1878434372/src/src/pages/tutorial.vue?macro=true";
import { default as agreement0tZlMWDj0bWTsbzh_DQ_45cPkzUq_45Ohrp7bU0lg1ZX6d4Meta } from "/codebuild/output/src1878434372/src/src/pages/agreement.vue?macro=true";
import { default as about_45passOaJ3_m_rnDCJMCK5aUXf0H81EyzQGqwRCz85X2atm3YMeta } from "/codebuild/output/src1878434372/src/src/pages/about-pass.vue?macro=true";
import { default as indexDLuc6lmQZDE0rly02AAShYGwg9xhaZIO0Y7m6WZo6aMMeta } from "/codebuild/output/src1878434372/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Zge03THsFjf_TK2ceFZRCjNaaDylF_FhT01WKw5LoIAMeta } from "/codebuild/output/src1878434372/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceG7t5kfjDR_9aPluM8zkFsoTpOIbHJ2K0NwihQeJindQMeta } from "/codebuild/output/src1878434372/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_931oRHc7fNwYX8PfohEbB37i7LTnyPpbmhkkvuy8TgRdwMeta } from "/codebuild/output/src1878434372/src/src/pages/notice/[id].vue?macro=true";
import { default as indexArk_45_459nAS0IajgQR3nXQCRZjb6xDJVCy2wGHmmI_45pAkMeta } from "/codebuild/output/src1878434372/src/src/pages/coupon/index.vue?macro=true";
import { default as indexaOPIf5Ytu3gAOIuRvvGuMEePl6TtgoUILOf21PEn7OUMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/index.vue?macro=true";
import { default as indexCmXSgSTsP5FMx7QbohB1gm65MhfwFrv0ZhxanIXxNooMeta } from "/codebuild/output/src1878434372/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93TTMFwKbgmxhoyMup8poQb2a8ZuRR3WHUWG0Zc4YIx5EMeta } from "/codebuild/output/src1878434372/src/src/pages/parking/[id].vue?macro=true";
import { default as indexP_izR5pn9CmCqIFWopD_6iwIoJq1GQvxU2ktzESLwLkMeta } from "/codebuild/output/src1878434372/src/src/pages/history/index.vue?macro=true";
import { default as index3IhTBjesnDtWb7PpeN9XCjqRZkeM5fB_etHnMDXzZeoMeta } from "/codebuild/output/src1878434372/src/src/pages/monthly/index.vue?macro=true";
import { default as index74_htxSSxuWMpZArFgRyquSKtTFz_45jqyLtoLa75CK58Meta } from "/codebuild/output/src1878434372/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexkRcYN_45CzOjV2fAsC3KSH57Iu6JGW25hGFn7HyIhzWFQMeta } from "/codebuild/output/src1878434372/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviRqxtiIl6xcvZZCz8cqVzwOtdSedmaLU69Qyc6qPhfY8Meta } from "/codebuild/output/src1878434372/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editbZYHaVTEQVI_5z5v0chw0RXoCqvcs4_45anzE7MSTxfSsMeta } from "/codebuild/output/src1878434372/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementzKV4lAhzeT5AZJr0q7HfI8d2f_45lRoUSxHxYWHDamaFkMeta } from "/codebuild/output/src1878434372/src/src/pages/pass-agreement.vue?macro=true";
import { default as index32Eh8f2ueJY1gCnD4uo1NC7FTtKEoqTQ6sPfnTeWKC0Meta } from "/codebuild/output/src1878434372/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dOGZmXnMeuCMfw_45AS4hckImUvz3l58jJut7Ke8o5vlEcMeta } from "/codebuild/output/src1878434372/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmLSN48sg_45RD3am_dl4lRhDMLR_45NaucyY40KaOORMfvxwMeta } from "/codebuild/output/src1878434372/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexDgedztDbjI8EEWmcQ3aaUHvyFy5ySFfsPznnjTzgTLoMeta } from "/codebuild/output/src1878434372/src/src/pages/card/create/index.vue?macro=true";
import { default as index8SWa_hh_45I7eEqtu6884Tm8HWBXRarQcg81wJUuypJkwMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm_45uXNfNbW_45pdskm64Xiedk4QNIAO_9KhnA1aTmdhgWLkMeta } from "/codebuild/output/src1878434372/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmfwiy0jz14MBaWOvcvEVCK2s3LXTTtsHRF_Y_45fpUyFrYMeta } from "/codebuild/output/src1878434372/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeyKYmmzuE9jIG5VGG80cE_AWWRdxgJ_Bqjk_45QkidXh1cMeta } from "/codebuild/output/src1878434372/src/src/pages/membership/complete.vue?macro=true";
import { default as registerMeJ8BCHchFpU5nz35sOu35yIqNmu1CiQCWPugFbRXDsMeta } from "/codebuild/output/src1878434372/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93NbZqJZIsQFbRdgG2lWvymrtVmRMP1Hrej92UXDvGuk4Meta } from "/codebuild/output/src1878434372/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmZY_gdRoIrfYaIBHM0TYZwm_S88CO5d7_Soy9rj_J814Meta } from "/codebuild/output/src1878434372/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_932jigJyo8CVvicWjEG7guLXPYz6wr_45S2PCohq3QLNyywMeta } from "/codebuild/output/src1878434372/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexyQgZ1avgnCb9fie7YCUk37wkS3XOuXcPVtYCPsuarJMMeta } from "/codebuild/output/src1878434372/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codegUE66BdQVOrHabdEHeIvVDuKdqRiC3yqbW1xfTZmaBIMeta } from "/codebuild/output/src1878434372/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeI0nwcWMfajmxt4aHVzbcrfO_yaWxY2vwvJ_45Gn_45gmJYMMeta } from "/codebuild/output/src1878434372/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete8T4LywawUX4NrNS9ou1G810dL_jtaIPBf2tTatPAQDQMeta } from "/codebuild/output/src1878434372/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerY7JtdbsDNy2aKk4aw3lXf_45Kjmud_45gyUtTbsC8CAHBUwMeta } from "/codebuild/output/src1878434372/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeQrW65enbrAV9JsVJBrmH4G_45kBbc_45rjvSbbB__KYakGYMeta } from "/codebuild/output/src1878434372/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexz9UNsR_d0Z5zcNvh9wA3Va0I4rULiBONeLUQHIhg89kMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmFk6ZHMuPxMHLw_7ZYzDuj4BCuctLQayz8drZcsmTUSUMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeC2Ms3FmLcw6KDGpabdPjPdPYefzrMXSYx_d2bDTMle0Meta } from "/codebuild/output/src1878434372/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexeD8qtztWnPO18S_B7QkBfTPxzyKIa6SE9BrkdlCgqrQMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93xAiRANw2w_451gvQ9_meCb2yan2mQpi_N49GZuhXveKvIMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete_45mCNkuk40gfOEAC5zHNyHIE56iRs1WEyzal14fyqQTYMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliascYy4yMFXHviCEqLbQUtqm1tMH_dMnKg7NQYbh0ytnD8Meta } from "/codebuild/output/src1878434372/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleM6ZCefqHJnzI_qHnPFmZ4ZV4oyYkvGxGQy3DEG0wXLwMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailSoHYOnwMxRCogUHce1AbArVWf0cCkI0F5Il9hByBy4cMeta } from "/codebuild/output/src1878434372/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmCkuP76OrWKxLaoYW_9owyrBF1XMUVC6h3VVEX75gnCIMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentVUaeB9w5Fkv31D1FGd__hNJ2onjoBXd2VIbh9cxhJywMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmyy7xSFTlJ3f7CCoTiEvkM7RPGNoI_45JMCxI3hd7plwEcMeta } from "/codebuild/output/src1878434372/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedaterIyszcglWwaw_45ajrBjimx40z5G7mRhzRhW2dwf5MIpAMeta } from "/codebuild/output/src1878434372/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete_45zmgPNsxTxI05GsgliHcCB92BpPKEb1uTSdEstvd2AkMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeDSEpkPy_45AVAT1vsOnpYw7A1521riLYDUcNQ5z7mrD1cMeta } from "/codebuild/output/src1878434372/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordpH2RElG3PF9aFPjI9_45ixnNcL9erasmDyX_45Ww7QeaAIsMeta } from "/codebuild/output/src1878434372/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasSqpOdeTl4nAZSW_ur0yiz2tDNP_45gWMf704LFIjn__WoMeta } from "/codebuild/output/src1878434372/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerFZFLoS8qvO5uyZfyR_PydU_OfNPDi703b6adn5JMDw0Meta } from "/codebuild/output/src1878434372/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeUYu112K0hANCVZoJn_KPhrtjlwZaj2T4YnX1pVFZ4QgMeta } from "/codebuild/output/src1878434372/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexl02CQEjusC73xwsuM9byoE5HcMUW3fjQogu_45i_45_b_psMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexIQNzedT_iI8y0IMbERJM13IAk_45fOuG2dp3V3PECZsTUMeta } from "/codebuild/output/src1878434372/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexXYoMebDXgH1amIumr_W_45HeMkXpfim2TRuWsyOo21a68Meta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexNLJeL3yP0KitInvZ1oH04RbENz8yzT30L5XlO7JInb8Meta } from "/codebuild/output/src1878434372/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateuBq25IXXo8lJUC3K_NsZiJnegrqvnGNQ7F8_45sUJ699sMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeIIkTs_au9Y6Io1CCStyKdLUowbizp1CS9iko_KLnlJoMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmJITpnBuuRbo4OvLjjPjJ94sh56siFp_XI1XLSSuBGvwMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexaOiBdO11HyKZRfVF82CSHpTyMx4MngaRVT3boD0lT2YMeta } from "/codebuild/output/src1878434372/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completemtNOEa_aT4nk4i3lbeBp9RhZwl59skyoHBCCXGRtYAAMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateiLchhqHQJr9zL0M4WC2dewqKZS1N0KnXAdsFb8kLbA8Meta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexHAI_45qdmueVcLsWa9WKQvaX52KiDZcpYDVXee_NzgLc4Meta } from "/codebuild/output/src1878434372/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexvL_45eEDh_lypOiyM_450ivQ5TbSNvckxdJMtssFMpnjAk0Meta } from "/codebuild/output/src1878434372/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeG8wm5h9z5tDu3O6FEO9_450C7kpszJV1Lm2ZxcV4fsKgUMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexSY6CSuRTkBMUMI8VK6jEzpou0PMhfMv8tBbzAN_fETYMeta } from "/codebuild/output/src1878434372/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code7xZof7tn1UXdD0jYLIYfeVdz251CvnKvuv_2ccBCyZ4Meta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index60D3ustoT8kQTmhuaXp7rdu4ekxy4heb1TYS0mhKcZIMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index2HhoezCQOoYBVY9a1csxM90XmFscuSDy0g_ZtH74XocMeta } from "/codebuild/output/src1878434372/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index2vXncsSHjGf_45UrbaQdPsefN2ferBK5DKjm3fqAZmo7MMeta } from "/codebuild/output/src1878434372/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update9lXxO6QnEnbrJix0srPcpvOB_45CKeUPyP2ONaJIsgfe8Meta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmdTaSkudtZJyKLm5c1XbRZaA2D5kTnpikfNimnHSwDkMMeta } from "/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuOIk2iVH_45Y480zzxMYJtL7GCPBRtX7i9tKfgROut3F0cMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexGFOvnwIxLJHG_45HWHpdxVjJstf2DoVHo_459mm_4558a44MYMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexArk_45_459nAS0IajgQR3nXQCRZjb6xDJVCy2wGHmmI_45pAkMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexP_izR5pn9CmCqIFWopD_6iwIoJq1GQvxU2ktzESLwLkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index74_htxSSxuWMpZArFgRyquSKtTFz_45jqyLtoLa75CK58Meta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexkRcYN_45CzOjV2fAsC3KSH57Iu6JGW25hGFn7HyIhzWFQMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexDgedztDbjI8EEWmcQ3aaUHvyFy5ySFfsPznnjTzgTLoMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm_45uXNfNbW_45pdskm64Xiedk4QNIAO_9KhnA1aTmdhgWLkMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmfwiy0jz14MBaWOvcvEVCK2s3LXTTtsHRF_Y_45fpUyFrYMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeyKYmmzuE9jIG5VGG80cE_AWWRdxgJ_Bqjk_45QkidXh1cMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerMeJ8BCHchFpU5nz35sOu35yIqNmu1CiQCWPugFbRXDsMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmZY_gdRoIrfYaIBHM0TYZwm_S88CO5d7_Soy9rj_J814Meta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codegUE66BdQVOrHabdEHeIvVDuKdqRiC3yqbW1xfTZmaBIMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeI0nwcWMfajmxt4aHVzbcrfO_yaWxY2vwvJ_45Gn_45gmJYMMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete8T4LywawUX4NrNS9ou1G810dL_jtaIPBf2tTatPAQDQMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerY7JtdbsDNy2aKk4aw3lXf_45Kjmud_45gyUtTbsC8CAHBUwMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmFk6ZHMuPxMHLw_7ZYzDuj4BCuctLQayz8drZcsmTUSUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeC2Ms3FmLcw6KDGpabdPjPdPYefzrMXSYx_d2bDTMle0Meta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexeD8qtztWnPO18S_B7QkBfTPxzyKIa6SE9BrkdlCgqrQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete_45mCNkuk40gfOEAC5zHNyHIE56iRs1WEyzal14fyqQTYMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleM6ZCefqHJnzI_qHnPFmZ4ZV4oyYkvGxGQy3DEG0wXLwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailSoHYOnwMxRCogUHce1AbArVWf0cCkI0F5Il9hByBy4cMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmCkuP76OrWKxLaoYW_9owyrBF1XMUVC6h3VVEX75gnCIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentVUaeB9w5Fkv31D1FGd__hNJ2onjoBXd2VIbh9cxhJywMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmyy7xSFTlJ3f7CCoTiEvkM7RPGNoI_45JMCxI3hd7plwEcMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete_45zmgPNsxTxI05GsgliHcCB92BpPKEb1uTSdEstvd2AkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeDSEpkPy_45AVAT1vsOnpYw7A1521riLYDUcNQ5z7mrD1cMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordpH2RElG3PF9aFPjI9_45ixnNcL9erasmDyX_45Ww7QeaAIsMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerFZFLoS8qvO5uyZfyR_PydU_OfNPDi703b6adn5JMDw0Meta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeUYu112K0hANCVZoJn_KPhrtjlwZaj2T4YnX1pVFZ4QgMeta || {},
    component: () => import("/codebuild/output/src1878434372/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1878434372/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]